/* ==========================================================================
   FS | PRO Campaign — shared behaviours
   Scroll reveals, wavelength glow selector, mode selector, testimonials,
   sticky buy bar and AJAX add-to-cart.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- global: scroll reveal ---------- */
  function initReveal(root) {
    if (reduce) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    $$('[data-rev]', root).forEach(function (el) {
      if (el.hasAttribute('data-rev-done')) return;
      el.setAttribute('data-rev-done', '');
      var d = el.getAttribute('data-rev-d');
      if (d) el.style.transitionDelay = d + 'ms';
      el.classList.add('pc-rev');
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.94) { el.classList.add('is-in'); } else { io.observe(el); }
    });
  }

  /* ---------- global: smooth-scroll anchors ---------- */
  function initScrollLinks(root) {
    $$('[data-scroll]', root).forEach(function (a) {
      if (a.hasAttribute('data-scroll-done')) return;
      a.setAttribute('data-scroll-done', '');
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('data-scroll'));
        if (!target) return;
        e.preventDefault();
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - 68,
          behavior: reduce ? 'auto' : 'smooth'
        });
      });
    });
  }

  /* ---------- global: add to cart ---------- */
  var toastTimer;
  function showToast() {
    var toast = $('.fs-pro [data-toast]');
    if (!toast) return;
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.style.opacity = '';
      toast.style.transform = '';
    }, 2600);
  }

  function refreshCartBubble() {
    try {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-icon-bubble' : '/?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections['cart-icon-bubble'];
          if (!html) return;
          var holder = document.getElementById('cart-icon-bubble');
          if (holder) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var inner = tmp.querySelector('.shopify-section') || tmp;
            holder.innerHTML = inner.innerHTML;
          }
        })
        .catch(function () {});
    } catch (e) { /* noop */ }
  }

  function markCheckout(btn) {
    if (!btn || btn.hasAttribute('data-checkout-mode')) return;
    btn.setAttribute('data-checkout-mode', '');
    var label = btn.querySelector('[data-btn-label]');
    if (label) label.textContent = btn.getAttribute('data-checkout-label') || 'Checkout';
  }

  function markStickyCheckout(except) {
    $$('.fs-pro [data-sticky] [data-add]').forEach(function (b) {
      if (b !== except) markCheckout(b);
    });
  }

  var checkoutChecked = false;
  function initCheckoutState() {
    if (checkoutChecked) return;
    var stickyBtn = $('.fs-pro [data-sticky] [data-add][data-variant-id]');
    if (!stickyBtn) return;
    checkoutChecked = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var vid = Number(stickyBtn.getAttribute('data-variant-id'));
        var inCart = (cart.items || []).some(function (it) { return it.variant_id === vid; });
        if (inCart) markStickyCheckout(null);
      })
      .catch(function () {});
  }

  function initAddToCart(root) {
    $$('[data-add]', root).forEach(function (btn) {
      if (btn.hasAttribute('data-add-done')) return;
      btn.setAttribute('data-add-done', '');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.hasAttribute('data-checkout-mode')) {
          window.location.href = '/checkout';
          return;
        }
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) {
          var url = btn.getAttribute('data-product-url');
          if (url) window.location.href = url;
          return;
        }
        if (btn._busy) return;
        btn._busy = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          showToast();
          refreshCartBubble();
          document.dispatchEvent(new CustomEvent('fs-pro:added'));
          var isSticky = !!btn.closest('[data-sticky]');
          markStickyCheckout(isSticky ? btn : null);
          var label = btn.querySelector('[data-btn-label]');
          if (label) {
            var w = btn.offsetWidth;
            btn.style.minWidth = w + 'px';
            var old = label.textContent;
            label.textContent = 'Added ✓';
            setTimeout(function () {
              btn._busy = false;
              if (isSticky) { markCheckout(btn); } else { label.textContent = old; }
            }, 1200);
          } else {
            btn._busy = false;
            if (isSticky) markCheckout(btn);
          }
        }).catch(function () {
          btn._busy = false;
          var url = btn.getAttribute('data-product-url');
          if (url) window.location.href = url;
        });
      });
    });
  }

  /* ---------- hide Gorgias chat on the campaign template ---------- */
  var gorgiasHidden = false;
  function initGorgiasHide() {
    if (gorgiasHidden) return;
    if (!document.body.classList.contains('template-page-pro-campaign')) return;
    gorgiasHidden = true;
    var hide = function () {
      var el = document.getElementById('gorgias-chat-container');
      if (el && el.style.display !== 'none') el.style.setProperty('display', 'none', 'important');
    };
    hide();
    try { new MutationObserver(hide).observe(document.body, { childList: true }); } catch (e) { /* noop */ }
    var tryApi = function (attempt) {
      try {
        if (window.GorgiasChat && typeof window.GorgiasChat.hideWidget === 'function') {
          window.GorgiasChat.hideWidget();
          return;
        }
      } catch (e) { /* noop */ }
      if (attempt < 20) setTimeout(function () { tryApi(attempt + 1); }, 500);
    };
    tryApi(0);
  }

  /* ---------- sticky buy bar ---------- */
  function initStickyBar(root) {
    var sticky = $('[data-sticky]', root);
    if (!sticky || sticky.hasAttribute('data-sticky-done')) return;
    sticky.setAttribute('data-sticky-done', '');
    var onScroll = function () {
      var hero = document.querySelector('.fs-pro [data-hero]');
      var threshold = hero ? hero.offsetTop + hero.offsetHeight * 0.66 : 520;
      sticky.style.transform = window.scrollY > threshold ? 'translateY(0)' : 'translateY(120%)';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- wavelength glow selector ---------- */
  function initWavelengths(root) {
    var grid = $('.pc-wv-grid', root);
    if (!grid || grid.hasAttribute('data-wv-done')) return;
    grid.setAttribute('data-wv-done', '');
    var cards = $$('.pc-wv-card', grid);
    var kicker = $('[data-wv-kicker]', root);
    var body = $('[data-wv-body]', root);
    if (!cards.length) return;
    var select = function (i) {
      cards.forEach(function (c, j) { c.toggleAttribute('data-active', j === i); });
      var c = cards[i];
      var name = c.getAttribute('data-wv-name') || '';
      var nm = c.getAttribute('data-wv-nm') || '';
      var desc = c.getAttribute('data-wv-desc') || '';
      var color = c.getAttribute('data-wv-color') || '';
      if (kicker) { kicker.textContent = (name + (nm ? ' · ' + nm : '')).toUpperCase(); kicker.style.color = color; }
      if (body) body.textContent = desc;
    };
    cards.forEach(function (c, i) {
      c.addEventListener('mouseenter', function () { select(i); });
      c.addEventListener('click', function () { select(i); });
      c.addEventListener('focus', function () { select(i); });
    });
    select(0);
  }

  /* ---------- mode selector ---------- */
  function initModes(root) {
    var grid = $('.fsp-modes-grid', root);
    if (!grid || grid.hasAttribute('data-pm-done')) return;
    grid.setAttribute('data-pm-done', '');
    var modes = $$('[data-mode]', grid);
    var jsonEl = $('[data-modes-json]', root);
    if (!modes.length || !jsonEl) return;
    var data = [];
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { /* noop */ }
    var mTitle = $('[data-mode-title]', root);
    var mDesc = $('[data-mode-desc]', root);
    var mNum = $('[data-mode-num]', root);
    var mTag = $('[data-mode-tag]', root);
    var select = function (i) {
      modes.forEach(function (m, j) { m.setAttribute('aria-selected', String(j === i)); });
      var d = data[i] || {};
      if (mTitle) mTitle.textContent = d.t || '';
      if (mDesc) mDesc.textContent = d.d || '';
      if (mNum) mNum.textContent = String(i + 1).padStart(2, '0');
      if (mTag) mTag.textContent = d.g || '';
    };
    modes.forEach(function (m, i) { m.addEventListener('click', function () { select(i); }); });
    select(0);
  }

  /* ---------- testimonials ---------- */
  function initTestimonials(root) {
    $$('[data-testi]', root).forEach(function (group) {
      if (group.hasAttribute('data-testi-done')) return;
      group.setAttribute('data-testi-done', '');
      var slides = $$('[data-testi-slide]', group);
      var dots = $$('[data-testi-dot]', group);
      if (!slides.length) return;
      var ti = 0;
      var auto;
      slides.forEach(function (s, j) {
        s.style.position = j === 0 ? 'relative' : 'absolute';
        s.style.inset = '0';
      });
      var show = function (i) {
        ti = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) {
          s.style.opacity = j === ti ? '1' : '0';
          s.style.pointerEvents = j === ti ? '' : 'none';
          s.style.position = j === ti ? 'relative' : 'absolute';
        });
        dots.forEach(function (d, j) { d.toggleAttribute('data-active', j === ti); });
      };
      $$('[data-testi-prev]', group).forEach(function (b) { b.addEventListener('click', function () { show(ti - 1); }); });
      $$('[data-testi-next]', group).forEach(function (b) { b.addEventListener('click', function () { show(ti + 1); }); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); }); });
      show(0);
      var start = function () { if (!reduce) auto = setInterval(function () { show(ti + 1); }, 6500); };
      var stop = function () { clearInterval(auto); };
      group.addEventListener('pointerenter', stop);
      group.addEventListener('pointerleave', start);
      start();
    });
  }

  function initAll() {
    initGorgiasHide();
    initCheckoutState();
    $$('.fs-pro').forEach(function (root) {
      initReveal(root);
      initScrollLinks(root);
      initAddToCart(root);
      initStickyBar(root);
      initWavelengths(root);
      initModes(root);
      initTestimonials(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
